import PropTypes from 'prop-types'
import React from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'
import MultiSelectPillList from '../../../../../components/MultiSelectPillList'

const propTypes = {
  /**
   * values of each field in the form
   */
  formValues: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * Callback to update the values in the form
   */
  updateForm: PropTypes.func.isRequired,
  /**
   * Object with options for each field
   */
  formOptions: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  /**
   * If true, disable fields
   */
  disabled: PropTypes.bool,
}

function TemplateGroupForm(props) {
  const { formValues = {}, updateForm, formOptions = {}, disabled = false } = props ?? {}

  const { groupName, groupDescription, selectedTemplatesIds } = formValues

  const intl = useIntl()

  return (
    <>
      <div className="text-strong mb-4">
        <FormattedMessage id="POLICY_GROUP.POLICY_SELECTION" />
      </div>

      <Row>
        <Col md="6">
          <MultiSelectPillList
            id="policyTemplatesSelect"
            title="POLICY_TEMPLATES.POLICY_TEMPLATES"
            options={formOptions.selectedTemplatesIds}
            values={selectedTemplatesIds}
            onChange={(values) => updateForm(values, 'selectedTemplatesIds')}
            isDisabled={disabled}
          />
        </Col>

        <Col md="6">
          <Form.Group controlId="groupName">
            <Form.Label>
              <FormattedMessage id="POLICY_GROUP.BASELINE_NAME" />
            </Form.Label>
            <Form.Control
              value={groupName}
              onChange={(event) => updateForm(event.target.value, 'groupName')}
              placeholder={intl.formatMessage({
                id: 'POSTURE_TEMPLATES.ADD_NAME',
              })}
              disabled={disabled}
            />
          </Form.Group>
        </Col>
      </Row>

      <hr />

      <div className="text-strong mb-4">
        <FormattedMessage id="POLICY_GROUP.BASELINE_DESCRIPTION" />
      </div>
      <Form.Group controlId="groupDescription" className="mb-4">
        <Form.Control
          as="textarea"
          rows={3}
          value={groupDescription}
          onChange={(event) => updateForm(event.target.value, 'groupDescription')}
          placeholder={intl.formatMessage({
            id: 'POLICY_GROUP.ENTER_DESCRIPTION',
          })}
          disabled={disabled}
        />
      </Form.Group>

      <hr />
    </>
  )
}

TemplateGroupForm.propTypes = propTypes

export default TemplateGroupForm
